import { render, staticRenderFns } from "./PowerRewriteContent.vue?vue&type=template&id=400416fa&scoped=true"
import script from "./PowerRewriteContent.vue?vue&type=script&lang=js"
export * from "./PowerRewriteContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400416fa",
  null
  
)

export default component.exports